var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-button" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-between text-nowrap btn-outer",
        class: _vm.styleClasses,
      },
      [
        _c(
          "button",
          {
            staticClass: "button flex-grow-1 text-left",
            on: { click: _vm.didClick },
          },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        _vm.icon !== "none"
          ? _c(
              "button",
              {
                class: _vm.iconClasses,
                on: {
                  click: function ($event) {
                    return _vm.didClick("inner", $event)
                  },
                },
              },
              [_vm._v("\n             \n        ")]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }